export default {
  data() {
    return {}
  },
  computed: {},
  methods: {
    _formatJavascriptDate: ({ date, timeZoneName } = {}) => {
      if (!date) {
        return ''
      }
      return date.toLocaleDateString('en-US', {
        hour12: false,
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: timeZoneName || 'short',
      })
    },
    _getBrowserTimezone: ({ format } = {}) => {
      // “long" (e.g., Pacific Standard Time)
      // “short" (e.g., PST)
      return new Date().toLocaleDateString('en-US', {
        timeZoneName: format,
      }).split(', ')[1]
    },
    // Generic helpers
    _entityById: ({ entityList, idKey, idValue } = {}) => {
      if (entityList && idKey && idValue) {
        return entityList.find(entity => entity[idKey] === idValue)
      }
    },
    _entityPropertyValueByName: ({ entityList, idKey, idValue, propertyKey, emptyText } = {}) => {
      if (entityList && idKey && idValue && propertyKey) {
        let entity = entityList.find(entity => entity[idKey] === idValue)
        if (entity && entity[propertyKey]) {
          return entity[propertyKey]
        }
      }
      return emptyText || '[UNKNOWN]'
    },
    // Specific helpers
    _activityTypeByIsStatus: ({ activityTypeList, isStatus } = {}) => {
      if (activityTypeList) {
        return activityTypeList.filter(activityType => activityType.isStatus === isStatus)
      }
    },
    _modelsByCategoryIdAndManufacturerId: ({ modelList, categoryId, manufacturerId } = {}) => {
      if (modelList && categoryId && manufacturerId) {
        return modelList.filter(model => model.isEnabled && model.categoryId === categoryId && model.manufacturerId === manufacturerId)
      }
      return []
    },
    _manufacturerByModelId: ({ modelList, manufacturerList, modelId } = {}) => {
      if (modelList, manufacturerList, modelId) {
        let model = modelList.find(model => model.id === modelId)
        if (model && model.manufacturerId) {
          let manufacturer = manufacturerList.find(manufacturer => manufacturer.id === model.manufacturerId)
          if (manufacturer) {
            return manufacturer
          }
        }
      }
      return {}
    },
    _categoryByModelId: ({ modelList, categoryList, modelId } = {}) => {
      if (modelList && categoryList && modelId) {
        let model = modelList.find(model => model.id === modelId)
        if (model && model.categoryId) {
          let category = categoryList.find(category => category.id === model.categoryId)
          if (category) {
            return category
          }
        }
      }
      return {}
    },
    _getMessageFromErrorResponse(error) {
      let message
      if (error && error.data && error.data.message) {
        message = error.data.message
        if (error.data.validationErrors) {
          message +=
            ' ' +
            Array.join(
              error.data.validationErrors.map((err) => err.message),
              '. '
            ) +
            '.'
        }
      } else {
        message =
          'Uh oh! Something bad happened when communicating with the server, please contact website support if the problem persists.'
      }
      return message
    },
    _getDateParts(date) {
      const tzOffset = (date).getTimezoneOffset() * 60000 //offset in milliseconds
      const localISOTimeString = (new Date(date - tzOffset)).toISOString()
      return {
        dateExtracted: localISOTimeString.split('T')[0],
        timeExtracted: localISOTimeString.split('T')[1].split('.')[0],
      }
    },
  },
}